import { createSelector } from 'reselect';

const selectLMSTopics = (state: any) => state.lmsTopics;


export const selectLMSTopicsCurrentItem = createSelector([selectLMSTopics], (lmsTopics) => lmsTopics.current);

export const selectLMSTopicsListItems = createSelector([selectLMSTopics], (lmsTopics) => lmsTopics.list);

export const selectLMSTopicsItemById = (itemId: any) =>
    createSelector(selectLMSTopicsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectLMSTopicsQueryItems = createSelector([selectLMSTopics], (lmsTopics) => lmsTopics.query);

export const selectLMSTopicsCreatedItem = createSelector([selectLMSTopics], (lmsTopics) => lmsTopics.create);

export const selectLMSTopicsUpdatedItem = createSelector([selectLMSTopics], (lmsTopics) => lmsTopics.update);

export const selectLMSTopicsReadItem = createSelector([selectLMSTopics], (lmsTopics) => lmsTopics.read);

export const selectLMSTopicsDeletedItem = createSelector([selectLMSTopics], (lmsTopics) => lmsTopics.delete);

export const selectLMSTopicsSearchedItems = createSelector([selectLMSTopics], (lmsTopics) => lmsTopics.search);

export const selectLMSTopicsItemsCount = createSelector([selectLMSTopics], (lmsTopics) => lmsTopics.count);

export const selectLMSTopicsItemsFilter = createSelector([selectLMSTopics], (lmsTopics) => lmsTopics.filter);